export enum EtapaEnum {
    MEUS_DADOS = 0,
    PLANOS = 1,
    VEICULO = 2,
    ENDERECO = 3,
    PAGAMENTO = 4
}